import WLogin from './Login';

WLogin.install = (Vue) => {
  Vue.component(WLogin.name, WLogin);
};

export default WLogin;
